import styled from '@emotion/styled';
import { TableCell, TableContainer, TableFooter } from '@mui/material';
import Theme from 'App.theme';

export const Table = styled.div`
  border: 1px solid ${Theme.greys.GREY1};
  border-radius: 0.5rem;
  overflow: hidden;
`;

export const Container = styled(TableContainer)`
  max-height: 600px;
`;

export const HeadTableCell = styled(TableCell)`
  background-color: ${Theme.greys.GREY1};
`;

export const Footer = styled(TableFooter)`
  display: table;
  width: 100%;
  border-top: 1px solid ${Theme.greys.GREY1};
`;
